import { NotFoundV2 } from '@findy-code/yuffie/shared/errors';

import { CompanyDetailComponent } from './components';
import type { FetchCompanyDetailQuery } from './graphql';

type Props = {
  isLogin: boolean;
  company?: FetchCompanyDetailQuery;
};

export const CompanyDetailContainer = ({ isLogin, company }: Props) => {
  return company?.company.id === undefined ? (
    <NotFoundV2 />
  ) : (
    <CompanyDetailComponent company={company.company} isLogin={isLogin} />
  );
};
